import React, { useState, useEffect } from "react"
import { useForm, FormProvider, useFieldArray } from "react-hook-form"
import { Form, Button, Row, Col, Alert } from "react-bootstrap"
import StateList from "./StateList"
import CityList from "./CityList"
import PlusSymbol from "./plus-symbol.svg"
import MinusSymbol from "./minus-symbol.svg"
import ModifyForm from "./ModifyForm"

export default function ContactForm({ travelAssistanceData, toggleSuccessMessage }) {

  const [selectedPersons, setSelectedPersons] = useState([]);

  //Checkbox change handler - check first and last names to ensure the values are unique
  const handleCheckboxChange = (person) => {
    if (selectedPersons.some(p => p.first_name === person.first_name && p.last_name === person.last_name)) {
      setSelectedPersons(selectedPersons.filter(p => p.first_name !== person.first_name || p.last_name !== person.last_name));
    } else {
      setSelectedPersons([...selectedPersons, person]);
    }
  };



  const {
    register,
    formState: { errors },
    reset,
    //errors,
    watch,
    handleSubmit,
    getValues,
    control,
    setValue,
  } = useForm({
    mode: "onSubmit",
    defaultValues: {
      persons: []
    }
  })

  const watchObject = watch()

  const [succeeded, setSucceeded] = useState(false)
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState("")
  const [disableSubmit, setDisableSubmit] = useState(false)

  const Required = () => <span style={styles.formError}>*</span>

  const styles = {
    formError: {
      color: "red",
      fontSize: "0.8rem",
      fontWeight: 700,
    },
  }
  console.log('watchObject', watchObject)
  const handleChange = async event => {
    setError(event.error ? event.error.message : "")
    console.log(watchObject)
  }

  const processFormData = data => {
    // Clone the data object to avoid mutating the original
    const processedData = { ...data }

    // Check if person is an array
    if (Array.isArray(processedData.person)) {
      // Iterate over each person object
      processedData.person = processedData.person.map(person => {
        // Check if veteran_service_org is an array
        if (Array.isArray(person.veteran_service_org)) {
          // Convert the array to a comma-delimited string
          person.veteran_service_org = person.veteran_service_org.join(", ")
        }
        return person
      })
    }

    return processedData
  }

  const submitForm = data => {
    // Process the form data
    //console.log(travelAssistanceData);
    const processedData = {
      ...processFormData(data),
      requester_first_name: travelAssistanceData.requester_first_name,
      requester_last_name: travelAssistanceData.requester_last_name,
      requester_email: travelAssistanceData.requester_email,
      requester_phone: travelAssistanceData.requester_phone
    };

    setProcessing(true)
    setDisableSubmit(true)
    //console.log('processedData', processedData)
    fetch(
      `https://script.google.com/macros/s/AKfycbwlZoUVeGoVddyum3G7BWFKgfUXZoKuX5_qzzbQW9-AzOhK1u9JtzLKhtJq8pQvXGymyw/exec`,
      {
        method: "POST",
        body: JSON.stringify(processedData),
      }
    )
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        return response.text()
      })
      
      .then(result => {
        console.log(result);
        fetch('/.netlify/functions/ses-travel-request', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(processedData),
      })
      .then(res => {
        console.log('mailgun response', res);
        if (res.status === 200) {
          console.log('Data submitted to Mailgun');
          setSucceeded(true);
          reset();
        } else {
            console.log('Error submiting to Mailgun')
        }
    }).catch((error) => {
      setSucceeded(false);
      setDisableSubmit(false);
      console.log('Mailgun error!', error.message);
      alert("Error: " + error.message)
    })
      })
      .catch(error => {
        setSucceeded(false)
        setDisableSubmit(false)
        console.error("Error:", error)
        alert("Error: " + error.message)
      })
      
    //   fetch('/.netlify/functions/mailgun-christening-request', {
    //       method: 'POST',
    //       headers: {
    //           'Content-Type': 'application/json',
    //       },
    //       body: JSON.stringify(processedData),
    //   })
    //   .then(res => {
    //     console.log('mailgun response', res);
    //     if (res.status === 200) {
    //       console.log('Data submitted to Mailgun');
    //       setSucceeded(true);
    //       reset();
    //       toggleSuccessMessage(false);
    //     } else {
    //         console.log('Error submiting to Mailgun')
    //     }
    // }).catch((error) => {
    //   setSucceeded(false);
    //   setDisableSubmit(false);
    //   console.log('Mailgun error!', error.message);
    //   alert("Error: " + error.message)
    // })
  }

  const SubmitRequestSuccessMessage = () => (
    <div className="submit-success-message text-center">
      <Alert variant="success">
      <h3>✅ Thank you for your submission!</h3>
        <div style={{ margin: "20px 0", padding: "15px", backgroundColor: "#e8f4f8", borderRadius: "8px" }}>
          <p style={{ marginBottom: "10px" }}><strong>IMPORTANT: Please Check Your Email</strong></p>
          <p style={{ fontSize: "1.2rem", color: "#0066cc", marginBottom: "10px" }}>
            A confirmation email has been sent to:<br />
            <strong>{travelAssistanceData.requester_email}</strong>
          </p>
          <p style={{ fontSize: "0.9rem", color: "#555" }}>
            Please check your inbox (and spam/junk folder) for confirmation within the next 5 minutes.<br />
            If you don't receive it, the email address may be incorrect.
          </p>
        </div>
        <p>An electronic RSVP will be sent several weeks before the Commissioning by the U.S. Navy if you are approved by the U.S. Navy to attend.</p>
        <p>
        Tickets to the Commissioning of USS IDAHO SSN 799 are controlled by and at the discretion of the U.S. Navy. The USS IDAHO Commissioning Committee will do everything it can do to advocate on your behalf but we cannot make any guarantees, implied or otherwise, as to whether you will be offered and/or receive a ticket or the number of tickets you requested from the U.S. Navy.
        </p>
        <p style={{fontSize: 'larger'}}><strong>Please complete form below to request travel assistance from Uniglobe Travel.</strong></p>
      </Alert>
    </div>
  )
  
  const SubmitSuccessMessage = () => (
    <div className="submit-success-message text-center">
      <Alert variant="success">
        <h3>Thank you for your submission.</h3>
        <p>A copy of your request has been emailed to you.</p>
        <p>A representative of Uniglobe Travel will be in touch shortly.</p>
      </Alert>
    </div>
  )

  console.log('selectedPersons', selectedPersons)
  return (
    <>
      {succeeded ? (
        <SubmitSuccessMessage />
      ) : (
        <>
        <SubmitRequestSuccessMessage />
        <h4>Travel Assistance Request from Uniglobe Travel</h4>
          <form
            onSubmit={handleSubmit(submitForm)}
            id="travel-request-form"
            name="travel-request-form"
            style={{fontSize: '1.125rem'}}
          >
            <Row>
              <Col>
              <div className="fade-in">
                  <Row>
                    <Col>
                      <Alert variant="warning">
                        <p style={{marginBottom: 0, fontWeight: 'bold', fontSize: '1.125rem'}}>
                          Uniglobe travel is NOT part of the USS IDAHO
                          Commissioning Committee. The USS IDAHO
                          Commissioning Committee does NOT guarantee the
                          services provided by UNIGLOBE and only offers
                          this information portal as a convience.
                        </p>
                      </Alert>
                    </Col>
                  </Row>

                  <Form.Control
                    type="hidden"
                    {...register("timestamp")}
                    value={travelAssistanceData.timestamp}
                  />

                  <Row>
                    <Col>
                      <Form.Group>
                        <fieldset>
                          <input
                            className="radio"
                            type="checkbox"
                            inline
                            label="Yes"
                            id={`uniglobe_acknowledge_yes`}
                            name={`uniglobe_acknowledge_yes`}
                            value="Yes"
                            {...register(
                              `uniglobe_acknowledge`
                            )}
                          />
                          <label
                            className="radioLabel"
                            htmlFor={`uniglobe_acknowledge_yes`}
                          >
                            I acknowlege and agree to the statement
                            above.
                          </label>
                        </fieldset>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            
            {watchObject.uniglobe_acknowledge === "Yes" && (
              <div style={{
                marginBottom: "2rem",
                border: "1px solid lightgray",
                padding: "1rem",
                borderRadius: "0.5rem",
              }}>
                <Row>
                  <Col>
                  <Form.Label><strong>Please select which persons for whom you're requesting travel assistance:</strong></Form.Label>
                  <Form.Group>
                    <fieldset>
                    {travelAssistanceData.person.map((item, index) => {
                      console.log('item', item);
                      return (
                        <div key={index}>
                          <input
                            className="radio"
                            type="checkbox"
                            value={item.first_name}
                            name={item.first_name}
                            id={`item.${index}first_name`}
                           //checked={selectedPersons.some(p => `${p.first_name}-${p.last_name}` === `${item.first_name}-${item.last_name}`)}
                            onChange={() => handleCheckboxChange(item)}
                          />
                          <label className="radioLabel" htmlFor={`item.${index}first_name`}>
                            {`${item.first_name} ${item.last_name}`}
                          </label>
                        </div>
                      ) 
                    })}
                    </fieldset>
                  </Form.Group>
                  </Col>
                </Row>
              </div>
            )}

            {selectedPersons.map((person, index) => (
              <>
            <div key={index} style={{
                marginBottom: "2rem",
                border: "1px solid lightgray",
                padding: "1rem",
                borderRadius: "0.5rem",
              }}>
                <div>
                  <h4>Uniglobe Travel Assistance for {person.first_name} {person.last_name}</h4>
                </div>

               <Row class="fade-in">
               <Col sm={12} md={6}>
                 <Form.Group>
                   <Form.Label className="question-label">
                     First Name
                     <Required />
                   </Form.Label>
                     <Form.Control
                       className="formField"
                       type="text"
                       value={person.first_name}
                       readOnly
                       {...register(`persons[${index}].first_name`)}
                     />
                 </Form.Group>
               </Col>
               <Col sm={12} md={6}>
                 <Form.Group>
                   <Form.Label>
                     Last Name
                     <Required />
                   </Form.Label>
                     <Form.Control
                       className="formField"
                       type="text"
                       value={person.last_name}
                       readOnly
                       {...register(`persons[${index}].last_name`)}
                     />
                 </Form.Group>
               </Col>
             </Row>
  
             <Row>
               <Col sm={12} md={6}>
                 <Form.Group>
                   <Form.Label>Email Address</Form.Label>
                     <Form.Control
                       className="formField"
                       type="text"
                       value={person.email}
                       readOnly
                       {...register(`persons[${index}].email`, {
                         pattern: {
                           value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                           message: "Enter a valid e-mail address",
                         },
                       })}
                     />
                 </Form.Group>
               </Col>
               <Col sm={12} md={6}>
                 <Form.Group>
                   <Form.Label>
                     Phone Number (mobile preferred)
                     <Required />
                   </Form.Label>
                     <Form.Control
                       className="formField"
                       type="text"
                       value={person.phone}
                       readOnly
                       {...register(`persons[${index}].phone`, {
                         pattern: {
                           value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                           message: "Please enter a valid phone number",
                         },
                       })}
                     />
                 </Form.Group>
               </Col>
             </Row>
            
            <div className="fade-in">
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Do you request an Airline Quote from
                    Uniglobe Travel?
                  </Form.Label>
                  <fieldset>
                    <input
                      className="radio"
                      type="radio"
                      label="Yes"
                      id={`persons[${index}].airline_quote_yes`}
                      name={`persons[${index}].airline_quote_yes`}
                      value="Yes"
                      {...register(
                        `persons[${index}].airline_quote`
                      )}
                    />
                    <label
                      className="radioLabel"
                      htmlFor={`persons[${index}].airline_quote_yes`}
                    >
                      Yes
                    </label>
                    <input
                      className="radio"
                      type="radio"
                      id={`persons[${index}].airline_quote_no`}
                      name={`persons[${index}].airline_quote_no`}
                      value="No"
                      {...register(
                        `persons[${index}].airline_quote`
                      )}
                      style={{ marginLeft: "2rem" }}
                    />
                    <label
                      className="radioLabel"
                      htmlFor={`persons[${index}].airline_quote_no`}
                    >
                      No
                    </label>
                  </fieldset>
                </Form.Group>
              </Col>
            </Row>

            {watchObject.persons[index].airline_quote ===
                "Yes" && (
                <div
                  className="fade-in"
                  style={{ marginBottom: "2rem" }}
                >
                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Preferred arrival date in Groton,
                          CT area
                        </Form.Label>
                        <Form.Row>
                          <Col sm={3}>
                            <Form.Control
                              as="select"
                              id="airline_arrival_date"
                              {...register(
                                `persons.[${index}].airline_arrival_date`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="FRI 17 APR">
                                FRI 17 APR
                              </option>
                              <option value="SAT 18 APR">
                                SAT 18 APR
                              </option>
                              <option value="SUN 19 APR">
                                SUN 19 APR
                              </option>
                              <option value="MON 20 APR">
                                MON 20 APR
                              </option>
                              <option value="TUE 21 APR">
                                TUE 21 APR
                              </option>
                              <option value="WED 22 APR">
                                WED 22 APR
                              </option>
                              <option value="THU 23 APR">
                                THU 23 APR
                              </option>
                              <option value="FRI 24 APR">
                                FRI 24 APR
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Preferred departure airport
                        </Form.Label>
                        <Form.Row>
                          <Col>
                            <Form.Control
                              as="select"
                              id="preferred_departure_airport"
                              {...register(
                                `persons.[${index}].preferred_departure_airport`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="BOI">
                                BOI - Boise
                              </option>
                              <option value="GEG">
                                GEG - Spokane
                              </option>
                              <option value="IDA">
                                IDA - Idaho Falls
                              </option>
                              <option value="PIH">
                                PIH - Pocatello
                              </option>
                              <option value="SLC">
                                SLC - Salt Lake City
                              </option>
                              <option value="LWS">
                                LWS - Lewiston
                              </option>
                              <option value="TWF">
                                TWF - Twin Falls
                              </option>
                              <option value="SUN">
                                SUN - Hailey / Sun Valley
                              </option>
                              <option value="OTHER">
                                OTHER (Specify)
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  {watchObject.persons && watchObject.persons[index] && watchObject.persons[index].preferred_departure_airport === "OTHER" && (
                    <Row>
                      <Col className="fade-in">
                        <Form.Group>
                          <Form.Label>
                            Other preferred departure airport
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter airport code or name"
                            name={`persons.[${index}].other_preferred_airport`}
                            {...register(
                              `persons.[${index}].other_preferred_airport`
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Secondary departure airport (If desired to consider)
                        </Form.Label>
                        <Form.Row>
                          <Col>
                            <Form.Control
                              as="select"
                              id="arrival_airport"
                              {...register(
                                `persons.[${index}].secondary_departure_airport`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="BOI">
                                BOI - Boise
                              </option>
                              <option value="GEG">
                                GEG - Spokane
                              </option>
                              <option value="IDA">
                                IDA - Idaho Falls
                              </option>
                              <option value="PIH">
                                PIH - Pocatello
                              </option>
                              <option value="SLC">
                                SLC - Salt Lake City
                              </option>
                              <option value="LWS">
                                LWS - Lewiston
                              </option>
                              <option value="TWF">
                                TWF - Twin Falls
                              </option>
                              <option value="SUN">
                                SUN - Hailey / Sun Valley
                              </option>
                              <option value="OTHER">
                                OTHER (Specify)
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                    {watchObject.persons[index].secondary_departure_airport ===
                        "OTHER" && (
                        <Col className="fade-in">
                          <Form.Group>
                            <Form.Label>
                              Other secondary airport
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`persons.[${index}].other_secondary_airport`}
                              {...register(
                                `persons.[${index}].other_secondary_airport`
                              )}
                            />
                          </Form.Group>
                        </Col>
                      )}
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Preferred arrival airport
                        </Form.Label>
                        <Form.Row>
                          <Col>
                            <Form.Control
                              as="select"
                              id="preferred_arrival_airport"
                              {...register(
                                `persons.[${index}].preferred_arrival_airport`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="PVD">
                                PVD - Providence Rhode
                                Island T.F. Green
                                International Airport
                              </option>
                              <option value="BDL">
                                BDL - Hartford Connecticut
                                Bradley International
                                Airport
                              </option>
                              <option value="OTHER">
                                OTHER (Specify)
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                    {watchObject.persons[index].preferred_arrival_airport ===
                        "OTHER" && (
                        <Col className="fade-in">
                          <Form.Group>
                            <Form.Label>
                              Preferred arrival airport
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`persons.[${index}].other_preferred_arrival_airport`}
                              {...register(
                                `persons.[${index}].other_preferred_arrival_airport`
                              )}
                            />
                          </Form.Group>
                        </Col>
                      )}
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Secondary arrival airport
                        </Form.Label>
                        <Form.Row>
                          <Col>
                            <Form.Control
                              as="select"
                              id="secondary_arrival_airport"
                              {...register(
                                `persons.[${index}].secondary_arrival_airport`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="PVD">
                                PVD - Providence Rhode
                                Island T.F. Green
                                International Airport
                              </option>
                              <option value="BDL">
                                BDL - Hartford Connecticut
                                Bradley International
                                Airport
                              </option>
                              <option value="OTHER">
                                OTHER (Specify)
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                    {watchObject.persons[index].secondary_arrival_airport ===
                        "OTHER" && (
                        <Col className="fade-in">
                          <Form.Group>
                            <Form.Label>
                              Other secondary arrival
                              airport
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`persons.[${index}].other_secondary_arrival_airport`}
                              {...register(
                                `persons.[${index}].other_secondary_arrival_airport`
                              )}
                            />
                          </Form.Group>
                        </Col>
                      )}
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Return trip - preferred arrival
                          airport
                        </Form.Label>
                        <Form.Row>
                          <Col>
                            <Form.Control
                              as="select"
                              id="return_preferred_arrival_airport"
                              {...register(
                                `persons.[${index}].return_preferred_arrival_airport`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="BOI">
                                BOI - Boise
                              </option>
                              <option value="GEG">
                                GEG - Spokane
                              </option>
                              <option value="IDA">
                                IDA - Idaho Falls
                              </option>
                              <option value="PIH">
                                PIH - Pocatello
                              </option>
                              <option value="SLC">
                                SLC - Salt Lake City
                              </option>
                              <option value="LWS">
                                LWS - Lewiston
                              </option>
                              <option value="TWF">
                                TWF - Twin Falls
                              </option>
                              <option value="SUN">
                                SUN - Hailey / Sun Valley
                              </option>
                              <option value="OTHER">
                                OTHER (Specify)
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                    {watchObject.persons[index].return_preferred_arrival_airport ===
                        "OTHER" && (
                        <Col className="fade-in">
                          <Form.Group>
                            <Form.Label>
                              Other preferred return arrival
                              airport
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`persons.[${index}].other_preferred_return_arrival_airport`}
                              {...register(
                                `persons.[${index}].other_preferred_return_arrival_airport`
                              )}
                            />
                          </Form.Group>
                        </Col>
                      )}
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Return trip - secondary arrival airport (If desired to consider)
                        </Form.Label>
                        <Form.Row>
                          <Col>
                            <Form.Control
                              as="select"
                              id="return_secondary_departure_airport"
                              {...register(
                                `persons.[${index}].return_secondary_departure_airport`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="BOI">
                                BOI - Boise
                              </option>
                              <option value="GEG">
                                GEG - Spokane
                              </option>
                              <option value="IDA">
                                IDA - Idaho Falls
                              </option>
                              <option value="PIH">
                                PIH - Pocatello
                              </option>
                              <option value="SLC">
                                SLC - Salt Lake City
                              </option>
                              <option value="LWS">
                                LWS - Lewiston
                              </option>
                              <option value="TWF">
                                TWF - Twin Falls
                              </option>
                              <option value="SUN">
                                SUN - Hailey / Sun Valley
                              </option>
                              <option value="OTHER">
                                OTHER (Specify)
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                    {watchObject.persons[index].return_secondary_departure_airport ===
                        "OTHER" && (
                        <Col className="fade-in">
                          <Form.Group>
                            <Form.Label>
                              Other secondary airport
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`persons.[${index}].other_secondary_return_airport`}
                              {...register(
                                `persons.[${index}].other_secondary_return_airport`
                              )}
                            />
                          </Form.Group>
                        </Col>
                      )}
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Desired departure date from Groton area
                        </Form.Label>
                        <Form.Row>
                          <Col sm={3}>
                            <Form.Control
                              as="select"
                              id="airline_departure_date"
                              {...register(
                                `persons.[${index}].airline_departure_date`
                              )}
                            >
                              <option value="">
                                Select
                              </option>
                              <option value="SUN 26 APR">
                                SUN 26 APR
                              </option>
                              <option value="MON 27 APR">
                                MON 27 APR
                              </option>
                              <option value="TUE 28 APR">
                                TUE 28 APR
                              </option>
                            </Form.Control>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              )}

            <Row>
          <Col>
                <Form.Group>
                  <Form.Label>
                    Comments for Uniglobe Travel
                  </Form.Label>
              <Form.Control
                type="text"
                name={`persons.[${index}].uniglobe_comments`}
                {...register(
                  `persons.[${index}].uniglobe_comments`
                )}
              />
            </Form.Group>
          </Col>
        </Row>
          </div>
          </div>
          </>
            ))}
            {watchObject.uniglobe_acknowledge === "Yes" && (
              <Row>
                <Button
                  type="submit"
                  variant="primary"
                  form="travel-request-form"
                  disabled={disableSubmit}
                  className="submitButton teamButton"
                >
                  {succeeded
                    ? "Message submitted"
                    : processing
                    ? "SUBMITTING..."
                    : "SUBMIT"}
                </Button>
              </Row>
            )}
            
          </form>
        </>
      )}
    </>
  )
}
